import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import { type APIResponse, type User } from "@/lib/types";
import { type MatterScheduledMessage } from "./../../../types/Matter";

export type UpsertMatterScheduledMessageInput = {
  active: boolean;
  content: string;
  description?: string | null;
  label: string;
  timezone?: string | null;
  triggerStatusId: string;
  incidentTypeIds: string[];
};

export const createMatterScheduledMessage = (
  data: UpsertMatterScheduledMessageInput,
) => {
  return authenticatedFastApiAxiosInstance
    .post<
      APIResponse<MatterScheduledMessage>
    >(`${baseFastApiMatterRoute}/scheduled-messages`, data)
    .then((res) => res.data);
};

export const updateMatterScheduledMessage = (
  data: Pick<MatterScheduledMessage, "id" | "dateModified"> &
    UpsertMatterScheduledMessageInput & { user?: User },
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      APIResponse<MatterScheduledMessage>
    >(`${baseFastApiMatterRoute}/scheduled-messages`, data)
    .then((res) => res.data);
};

export const deleteMatterScheduledMessage = (
  data: Pick<MatterScheduledMessage, "id">,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<
      APIResponse<MatterScheduledMessage>
    >(`${baseFastApiMatterRoute}/scheduled-messages/${id}`)
    .then((res) => res.data);
};
